/**
 * voice-v8 — Chat-History-Sync (Phase: Cross-Device).
 *
 * Holt die letzten N chat_messages aus der Server-DB. Frontend nutzt das
 * beim Bootstrap als Augmentation des localStorage-Caches: Voice-Sessions
 * vom Handy und Chat vom Desktop sind damit auf jedem Gerät sichtbar.
 */

interface ServerToolCard {
  tool: string;
  callId: string;
  isError: boolean;
  result: unknown;
  anzeige?: unknown;
}

interface ServerChatMessage {
  id: string;
  sessionId: string;
  role: "user" | "assistant" | "system";
  content: string;
  createdAt: string; // ISO
  // Pre.172: Tool-Cards aus chat_messages.metadata.toolCards.
  // Pre.531: imageUrl bei User-Messages (Beleg-Upload, Bild-Anhang)
  // damit Cross-Device-Hydrate auf Desktop auch die Image-Bubble zeigt.
  metadata?: {
    toolCards?: ServerToolCard[];
    imageUrl?: string;
  } | null;
}

export async function fetchChatHistory(
  opts: {
    limit?: number;
    sinceIso?: string;
    beforeIso?: string;
    /** Ticket 2634: die Nachfrage nach dem Hänger darf nicht ewig warten. */
    signal?: AbortSignal;
  } = {},
): Promise<ServerChatMessage[]> {
  const url = new URL("/api/chat/history", window.location.origin);
  url.searchParams.set("limit", String(opts.limit ?? 100));
  if (opts.sinceIso) url.searchParams.set("since", opts.sinceIso);
  // 2026-07-03 (Martin, #36): aeltere Nachrichten nachladen (Hochscrollen).
  if (opts.beforeIso) url.searchParams.set("before", opts.beforeIso);
  const res = await fetch(url.toString(), {
    credentials: "same-origin",
    ...(opts.signal ? { signal: opts.signal } : {}),
  });
  if (!res.ok) {
    if (res.status === 503) return []; // history-not-available im Single-User-Mode
    throw new Error(`chat history fetch failed: ${res.status}`);
  }
  const data = (await res.json()) as { items: ServerChatMessage[] };
  return data.items;
}
